SNI.Application.addModule('story-promo', context => ({
  behaviors: ['lazy-load', 'multi-component-dynamic-ad', 'invoke-video-overlay']
}));
